export const ANALYTICS_NOTES_COMMON = 'analyticsNotesCommon';

export const ANALYTICS_NOTES_COMMON_ACTIONS_NAME = {
  searchCountryDeclensions: `${ANALYTICS_NOTES_COMMON}/searchCountryDeclensions`,
} as const;

export const ANALYTICS_NOTES_COMMON_MUTATIONS_NAME = {
  setCountryDeclensions: `${ANALYTICS_NOTES_COMMON}/setCountryDeclensions`,
} as const;

export const ANALYTICS_NOTES_COMMON_GETTERS_NAME = {
  getCountryDeclensions: `${ANALYTICS_NOTES_COMMON}/getCountryDeclensions`,
} as const;
